"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = safely_convert_rgb_to_rgba;
var _addAlpha = _interopRequireDefault(require("../add-alpha"));
var _isNoData = _interopRequireDefault(require("../is-no-data"));
var _makeNoDataRgba = _interopRequireDefault(require("../make-no-data-rgba"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function safely_convert_rgb_to_rgba(old_no_data_value, new_no_data_value, pixel) {
  return (0, _isNoData.default)(old_no_data_value, pixel) ? (0, _makeNoDataRgba.default)(new_no_data_value) : (0, _addAlpha.default)(pixel);
}